export default __webpack_public_path__ + "6f045df462fc5c57eafb43715b504106.png";